import * as React from 'react';
import { routes } from '@src/config/constants';
import { DifficultyOptions, Recipe } from '@src/firebase/types';

interface ViewRecipeListItemProps {
  className?: string;
  recipe: Recipe;
}

/**
 * @name ViewRecipeListItem
 * @description tbd...
 */
const ViewRecipeListItem: React.FC<ViewRecipeListItemProps> = (props) => {
  const { className, recipe } = props;

  // Setup
  const link = `${routes.view}/${recipe.friendlyUrl}`;
  const difficulty = DifficultyOptions[recipe.difficulty];

  return (
    <div className={className}>
      <a key={recipe.id} href={link} className="group">
        <div className="w-full aspect-w-1 aspect-h-1 bg-gray-200 rounded-lg overflow-hidden xl:aspect-w-7 xl:aspect-h-8">
          <img
            src={recipe.imageUrl}
            alt={recipe.name}
            className="w-full h-full object-center object-cover group-hover:opacity-75"
          />
        </div>
        <div className="mt-4 flex items-center justify-between text-base font-medium text-gray-900">
          <h3>{recipe.name}</h3>
          <p>{difficulty}</p>
        </div>
        <p className="mt-1 text-sm italic text-gray-500">
          {recipe.description}
        </p>
      </a>
    </div>
  );
};

export { ViewRecipeListItem };
export type { ViewRecipeListItemProps };
